import React, { useEffect, useState } from 'react';

import useNumberInput from '@hooks/useNumberInput';

import { NumberPropTypes, InputPropsType } from './types';
import LargeNumberInput from './LargeNumberInput';
import MediumNumberInput from './MediumNumberInput';
import MobileNumberInput from './MobileNumberInput';

const NumberInput: React.FC<NumberPropTypes> = ({
  onIncrement,
  onDecrement,
  onChange,
  value,
  currVariantId,
  step = 1,
  max = 100000,
  enableErrorStyle = false,
  className,
  type,
  disabled,
}: NumberPropTypes) => {
  const [loading] = useState<boolean>(false);
  const [inputValue, setInputValue] = useState<string | number | undefined>(value);
  const [onInput, setOnInput] = useState(0);

  const handleBlur = () => ({});

  const { incrementButton, decrementButton, input, prevNextValue } = useNumberInput({
    min: 0,
    max,
    value,
    focusInputOnChange: false,
    onChange,
    onIncrement,
    onDecrement,
    onBlur: handleBlur,
    loading,
    step,
    setInputValue,
    onInput,
    setOnInput,
  });

  // clear prevNextValue to resolve issue https://github.com/nanocohub/xshop/issues/344
  useEffect(() => {
    if (currVariantId) prevNextValue.current = null;
  }, [currVariantId]);

  useEffect(() => {
    setInputValue(value);
  }, [value, onInput]);

  const props: InputPropsType = {
    className,
    enableErrorStyle,
    incrementButton,
    decrementButton,
    inputValue,
    input,
    loading,
    disabled,
  };

  if (type === 'large') return <LargeNumberInput {...props} />;

  if (type === 'medium') return <MediumNumberInput {...props} />;

  return <MobileNumberInput {...props} />;
};

export default NumberInput;
